import { ILabelOption } from '@shared/common/common-types';

const getYesNoOptions = (l: (key: string) => string): ILabelOption[] => [
    { label: l('Yes'), value: true },
    { label: l('No'), value: false },
];

const getAllYesNoOptions = (l: (key: string) => string): ILabelOption[] => [
    { label: l('All'), value: null },
    { label: l('Yes'), value: true },
    { label: l('No'), value: false },
];

export { getYesNoOptions, getAllYesNoOptions };
